// extracted by mini-css-extract-plugin
module.exports = {"App__wrapper":"App_App__wrapper__Qs9mJ","App__answers":"App_App__answers__2WOB8"};